<script lang="ts">
import { defineComponent } from 'vue'
import SettingMixin from '@/modules/common/components/mixins/setting.mixin'

export default defineComponent({
  name: 'SwitchSetting',

  mixins: [SettingMixin],

  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      regTypeToAdd: {} as Record<string, any> | null,
      search: ''
    }
  },

  computed: {
    regTypesThatDontHaveSettings (): any[] {
      return (this as any).regTypesFiltered.filter(({ value }: any) => !(this as any).regTypeHasSetting(value))
    },

    regTypesThatDoHaveSettings (): any[] {
      return (this as any).regTypesFiltered.filter(({ value, text }: any) => (this as any).regTypeHasSetting(value) && text.toLowerCase().includes(this.search.toLowerCase()))
    }
  },

  methods: {
    /**
     * overrideDefaultSetting adds the given reg type to the settings value and initializes it to the provided default. Fallback is false.
     * TODO(zb): will need to change the fallback for different input types.
     * @param uuid {string}
     */
    overrideDefaultSetting (uuid: string) {
      this.regTypeToAdd = {}
      const copy = structuredClone((this as any).setting)
      copy[uuid] = (this as any).default ?? false
      this.$emit('input', copy)
    }
  }
})
</script>

<template>
  <div>
    <v-row v-if="!defaultRegistrationOnly">
       <v-col>
         <v-text-field
           hint="Search for the registration type"
           label="Search for registration type"
           v-model="search"
           single-line
           outlined
           solo
           flat
           :disabled="disabled"
         />
       </v-col>
       <v-col class="d-flex flex-row justify-content-center">
         <v-select
           hint="Select which registration type you want an override for"
           :disabled="disabled || regTypesThatDontHaveSettings.length === 0"
           label="Add an override for a registration type."
           :items="regTypesThatDontHaveSettings"
           v-model="regTypeToAdd"
           return-object
           hide-selected
           single-line
           outlined
           solo
           flat
         />
         <v-btn
           class="priority-focus ml-8 mb-8"
           @click.stop="overrideDefaultSetting(regTypeToAdd.value)"
           :disabled="disabled || Object.keys(regTypeToAdd).length === 0"
         >
           Add To List
         </v-btn>
       </v-col>
    </v-row>
    <v-list :class="regTypesThatDoHaveSettings.length > 3 ? 'constrain' : ''">
      <v-list-item v-for="item in regTypesThatDoHaveSettings" :key="item.value">
        <v-list-item-content>
          {{ item.text }}
        </v-list-item-content>
        <v-btn v-if="item.value !== '_default' && regTypeHasSetting(item.value)" class="priority-danger" @click.stop="useDefaultSetting(item.value)" :disabled="disabled">Remove Override</v-btn>
        <v-btn v-if="!regTypeHasSetting(item.value)" class="priority-focus" @click.stop="overrideDefaultSetting(item.value)" :disabled="disabled">Override for Registration Type</v-btn>
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-switch v-if="regTypeHasSetting(item.value)" v-model="setting[item.value]" @click.native.stop class="ml-8" v-on="on" v-bind="attrs" :disabled="disabled" />
            <v-switch v-else :value="setting._default" @click.native.stop="overrideDefaultSetting(item.value)" class="ml-8" v-on="on" v-bind="attrs" :disabled="disabled" />
          </template>
        </v-tooltip>
      </v-list-item>
    </v-list>
  </div>
</template>

<style>
.constrain {
  max-height: 200px;
  overflow-y: scroll;
}
</style>
